export default __webpack_public_path__ + "static/screenSecondSectionUk-58b4401d6de0479a5978ae2e3ef61773.webp";